export const to24HourTime = (time12h: string): string => {
  const match = time12h.trim().match(/^(\d{1,2}):(\d{2})\s?(AM|PM)$/i);
  if (!match)
    throw new RangeError("Invalid time format, expected 'hh:mm AM/PM'");

  const [_, h, m, meridian] = match;
  let hours = Number.parseInt(h ?? "0", 10);
  const minutes = Number.parseInt(m ?? "0", 10);

  if (meridian?.toUpperCase() === "PM" && hours < 12) hours += 12;
  if (meridian?.toUpperCase() === "AM" && hours === 12) hours = 0;

  // Validate the final 24-hour time range
  if (hours < 0 || hours > 23) {
    throw new RangeError("Invalid time, hours must be between 00 and 23");
  }
  if (minutes < 0 || minutes > 59) {
    throw new RangeError("Invalid time, minutes must be between 00 and 59");
  }

  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
};

/**
 * Converts a 24-hour time string (HH:mm:ss or HH:mm) to 12-hour format (hh:mm a)
 */
export const to12HourTime = (time24h: string): string => {
  const match = time24h.trim().match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
  if (!match)
    throw new RangeError("Invalid time format, expected 'HH:mm:ss' or 'HH:mm'");

  const [_, h, m] = match;
  let hours = Number.parseInt(h ?? "0", 10);
  const minutes = Number.parseInt(m ?? "0", 10);

  // Validate the input 24-hour time range
  if (hours < 0 || hours > 23) {
    throw new RangeError("Invalid time, hours must be between 00 and 23");
  }
  if (minutes < 0 || minutes > 59) {
    throw new RangeError("Invalid time, minutes must be between 00 and 59");
  }

  const meridian = hours >= 12 ? "PM" : "AM";
  if (hours === 0) hours = 12;
  else if (hours > 12) hours -= 12;

  return `${hours}:${String(minutes).padStart(2, "0")} ${meridian}`;
};
